import i18next from "i18next";

export function getLastPartOfURL() {
  const hashPath = window.location.hash?.startsWith("#/")
    ? window.location.hash.slice(1).split("?")[0]
    : window.location.pathname;

  const pathParts = hashPath.split("/").filter(Boolean);
  return pathParts[pathParts.length - 1] || "";
}

export const globalT = (text) => {
  return i18next.t(`globales.${text}`);
};

// Producción se sirve con HashRouter (rutas tipo `/#/checker/category/`) salvo
// que `REACT_APP_ROUTER_MODE` diga lo contrario. Vive aquí, y no en AppRouter,
// porque `consumeUnedReturn()` necesita la misma regla para reconstruir la
// ubicación al volver del SSO de la UNED.
export const shouldUseHashRouter = () => {
  const routerMode = (process.env.REACT_APP_ROUTER_MODE || "").toLowerCase();

  if (routerMode === "hash") {
    return true;
  }

  if (routerMode === "browser") {
    return false;
  }

  return process.env.NODE_ENV === "production";
};
